// Home "Coming up" widget — one-click Join for calendar events that already
// look like a call (board §2 "events/coming-up: next events with JOIN
// button for meet-linked ones"). Reuses the calendar package's OWN join
// dispatch verbatim (calendar/components/EventDetailModal.js's "Join call"
// SaveBtn: find-or-create a meet_rooms row keyed by calendarEventId, then
// hand off activeRoomId/meetView) rather than inventing a second one —
// `createRoom`/`connectCall` are already globally el.call-able (meet's
// eager slice, see workspace/sharedLibraries.js) from any route, exactly
// how EventDetailModal itself calls them from the calendar package.
//
// "meet-linked" is a real signal, not every event: `root.intranetEvents`
// (the home summary feed) carries no explicit meetUrl/meetingMode field,
// so the only two honest signals available here are (1) a meet_rooms row
// already scheduled for this event (root.rooms — shell-eager, see
// loadPrivateData.js's workspace-change meet.rooms fetch) or (2) the
// event's own description carrying a call link — the SAME heuristic
// EventDetailModal's EditBtn already uses to infer meetingMode from
// existing event data. Events without either signal still open fine (the
// card's onClick opens the full detail modal, which has its own
// unconditional "Join call" button) — this just skips the card-level
// shortcut for events that don't look like a call.

const _MEET_LINK_RE = /\/meet#room=|https?:\/\//i

export const eventHasMeetLink = function (event) {
  if (!event) return false
  const root = this && this.state && this.state.root
  const rooms = (root && root.rooms) || []
  if (
    event.id != null &&
    Array.isArray(rooms) &&
    rooms.some((r) => r.calendarEventId === event.id)
  ) {
    return true
  }
  return _MEET_LINK_RE.test(event.description || '')
}

// Find or create the room, seed the call state, and open its durable URL.
export const joinEventCall = async function (event) {
  const root = this && this.state && this.state.root
  if (!root || !event) return
  const existing = (root.rooms || []).find((r) => r.calendarEventId === event.id)
  let id = existing?.id
  if (!id) {
    id = await this.call('createRoom', {
      name: event.title || this.call('polyglot', 'workspace.meet.calendarCall'),
      kind: 'scheduled',
      calendarEventId: event.id,
      transcribeEnabled: true
    })
  }
  if (!id) {
    this.call('openNotification', {
      type: 'error',
      title: this.call('polyglot', 'workspace.meet.startFailed'),
      message: this.call('polyglot', 'workspace.meet.startFailedBody')
    })
    return
  }
  root.update({ activeRoomId: id, meetView: 'call' })
  // Complete the explicit join before mounting Meet, so its seed sees the
  // live room instead of opening a second pre-join preview.
  await this.call('connectCall', id)
  const hash = 'room=' + encodeURIComponent(id) + '&view=call'
  this.call('openAppPage', '/meet#' + hash)
}
